import React from 'react'
import ContainerUnauthenticated from 'containers/Unauthenticated'
import FormCore from 'components/Form/Core'
import Button from 'components/Form/Button'
import useController from './controller'
import { Screen, Intro, FormPanel, Actions, Message } from './styled'

export default function CompleteProfile({ area }) {
  const { t, formRef, formItems, session, initialValues, loading, saving, error, save, logout } = useController(area)
  return (
    <ContainerUnauthenticated success>
      <Screen aria-busy={loading || saving}>
        <Intro>
          <span>{t(`area_${area}_name`)}</span>
          <h1>{t('profile_completion_title')}</h1>
          <p>{t('profile_completion_description')}</p>
        </Intro>
        <FormPanel>
          {loading ? <p role="status">{t('area_loading')}</p> : session ? (
            <form onSubmit={event => { event.preventDefault(); save() }}>
              <FormCore ref={formRef} formItems={formItems} register={initialValues} disabled={saving} />
              <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
              <Actions><Button color="blue" onClick={save} loading={saving}>{t('profile_completion_save')}</Button></Actions>
            </form>
          ) : null}
          {error ? <Message role="alert">{t('profile_completion_error')}</Message> : null}
          <Actions><Button link onClick={logout} disabled={saving}>{t('area_sign_out')}</Button></Actions>
        </FormPanel>
      </Screen>
    </ContainerUnauthenticated>
  )
}
